'use strict';

function utfDecode(c) {
    if (c >= 93) c--;
    if (c >= 35) c--;
    return c - 32;
}

module.exports = function(data) {
    return function(x, y) {
        if (!data) return;
        var idx = utfDecode(data.grid[y].charCodeAt(x)),
            key = data.keys[idx];
        return data.data[key];
    };
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/src/grid.js
 ** module id = 962
 ** module chunks = 0 1 3 4 5 6
 **/